/*-- import aliases -----------
'!/...' -> project root
'~/...' -> js folder root
-----------------------------*/
import { setup } from "~/core";
setup();

import "~/global/_body";
import "~/global/_header";
// import "~/global/_headerSide"; Commenting out because of new mobile designs that use _sideNavMobile for now
import "~/global/_footer";
import "~/global/_searchFilters";
import "~/global/_sideNavMobile";
import "~/global/_sideNavScrolling";
import "~/global/_siteModals";
import "~/global/_textTruncate";
import "~/global/_sidebarResize";

import "~/components/_accordion";
import "~/components/_carouselSwiper";
import "~/components/_eventSchedule";
import "~/components/_filters";
import "~/components/_forms";
import "~/components/_productHeader";
import "~/components/_productTags";
import "~/components/_tooltips";
import "~/components/_stat";
import "~/components/_viewToggle";
import "~/components/_dragUploader";
import "~/components/_collapsibleTable";
import "~/components/_pageNav";
import "~/components/_colorPicker";
// import "~/components/_countdown";
